const IndustryCertificates = () => {
  return (
    <>
      <div className="card mb-4 bg-gradient-premium backdrop-filter-20px border-common">
        <div className="card-body p-4 text-center">
          <div className="fs-1 mb-3">🏆</div>
          <h6 className="text-white fw-bold">Industry Certificate</h6>
          <p className="text-white opacity-90 mb-3">Get certified in Web Development</p>
          <div className="row text-center">
            <div className="col-6">
              <div className="text-white fw-bold">JS-FUND-2024</div>
              <small className="text-white opacity-75">Credential ID</small>
            </div>
            <div className="col-6">
              <div className="text-white fw-bold">2 years</div>
              <small className="text-white opacity-75">Valid For</small>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default IndustryCertificates;